/**
 * @generated SignedSource<<ab343826ee6cc27887d90b1826f6ed9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type DashboardSkillsByTargetQuery$variables = {
  targetId: string;
};
export type DashboardSkillsByTargetQuery$data = {
  readonly target: {
    readonly targetSkills: ReadonlyArray<{
      readonly id: string;
      readonly isActive: boolean;
      readonly skill: {
        readonly code: string | null | undefined;
        readonly difficulty: any;
        readonly id: string;
        readonly name: string | null | undefined;
        readonly skillAncestries: ReadonlyArray<{
          readonly ancestorSkill: {
            readonly code: string | null | undefined;
            readonly difficulty: any;
            readonly id: string;
            readonly name: string | null | undefined;
          } | null | undefined;
          readonly skillRelevance: {
            readonly id: string;
            readonly name: string | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly targetSkillType: {
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type DashboardSkillsByTargetQuery = {
  response: DashboardSkillsByTargetQuery$data;
  variables: DashboardSkillsByTargetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targetId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "targetId",
    "variableName": "targetId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = [
  (v2/*: any*/),
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "TargetSkillTypeNode",
  "kind": "LinkedField",
  "name": "targetSkillType",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "difficulty",
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "skillRelevanceIds": [
        "SkillRelevanceNode:2",
        "SkillRelevanceNode:3"
      ]
    }
  }
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "ancestorSkill",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v4/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillRelevanceNode",
  "kind": "LinkedField",
  "name": "skillRelevance",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardSkillsByTargetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TargetNode",
        "kind": "LinkedField",
        "name": "target",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetSkillNode",
            "kind": "LinkedField",
            "name": "targetSkills",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillNode",
                "kind": "LinkedField",
                "name": "skill",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": (v9/*: any*/),
                    "concreteType": "SkillAncestryNode",
                    "kind": "LinkedField",
                    "name": "skillAncestries",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": "skillAncestries(filter:{\"skillRelevanceIds\":[\"SkillRelevanceNode:2\",\"SkillRelevanceNode:3\"]})"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardSkillsByTargetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TargetNode",
        "kind": "LinkedField",
        "name": "target",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TargetSkillNode",
            "kind": "LinkedField",
            "name": "targetSkills",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SkillNode",
                "kind": "LinkedField",
                "name": "skill",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": (v9/*: any*/),
                    "concreteType": "SkillAncestryNode",
                    "kind": "LinkedField",
                    "name": "skillAncestries",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": "skillAncestries(filter:{\"skillRelevanceIds\":[\"SkillRelevanceNode:2\",\"SkillRelevanceNode:3\"]})"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1b8a79aa859d479120d7a0646ec41673",
    "id": null,
    "metadata": {},
    "name": "DashboardSkillsByTargetQuery",
    "operationKind": "query",
    "text": "query DashboardSkillsByTargetQuery(\n  $targetId: ID!\n) {\n  target(targetId: $targetId) {\n    targetSkills {\n      id\n      isActive\n      targetSkillType {\n        id\n        name\n      }\n      skill {\n        id\n        name\n        code\n        difficulty\n        skillAncestries(filter: {skillRelevanceIds: [\"SkillRelevanceNode:2\", \"SkillRelevanceNode:3\"]}) {\n          ancestorSkill {\n            id\n            name\n            code\n            difficulty\n          }\n          skillRelevance {\n            id\n            name\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a486b311928ae4604de11572446d8abd";

export default node;
